import CategoryNav from "@/components/landing/CategoryNav";
import Hero from "@/components/landing/Hero";
import TrustPillars from "@/components/landing/TrustPillars";
import ProductSection from "@/components/landing/ProductSection";
import WhySpain from "@/components/landing/WhySpain";
import Process from "@/components/landing/Process";
import ContactForm from "@/components/landing/ContactForm";
import EventPopup from "@/components/landing/EventPopup";

export default function NuumaLanding() {
  return (
    <>
      <Hero />
      <CategoryNav />

      <TrustPillars />

      <ProductSection
        id="zdrowie"
        badgeType="remote"
        badgeLabel="Zdalnie · Próbki z Polski"
        title="Profilaktyka i Diagnostyka Zdrowia"
        description="Wykorzystaj DNA jako instrukcję obsługi swojego organizmu. Dowiedz się, jak Twoje geny wpływają na codzienne samopoczucie i zdrowie."
        features={[
          { label: "Nietolerancje", text: "Celiakia, laktoza, metabolizm witamin." },
          { label: "Nowotwory", text: "Ryzyko zmian dziedzicznych (piersi, jajnika)." },
          { label: "Zdrowie Serca", text: "Markery układu krążenia i stanów zapalnych." },
        ]}
        ctaLabel="Zapytaj o test zdrowotny"
        imageSrc="/assets/NUUMA_Genetics_Profilaktyka_i_diagnostyka.webp"
        imageAlt="Profilaktyka i diagnostyka genetyczna Nuuma"
      />

      <ProductSection
        id="match"
        variant="extended"
        reverse={false}
        badgeType="remote"
        badgeLabel="Zdalnie · Próbki z Polski"
        title="Secure Match – Test Zgodności Genetycznej"
        description={<>Większość z nas jest zdrowymi nosicielami co najmniej kilku wadliwych genów. Jeśli oboje partnerzy noszą mutację w tym samym genie, istnieje wysokie ryzyko wystąpienia choroby u dziecka.<br /><br />Najnowocześniejsze testy zgodności genetycznej dla par pozwalają wykluczyć ryzyko przekazania potomstwu ciężkich chorób recesywnych i sprzężonych z chromosomem X. Test analizuje od 15 do nawet 552 genów, zapewniając maksymalne bezpieczeństwo genetyczne przyszłego dziecka.</>}
        accordions={[
          { title: "Pakiet Basic", content: "Badanie 15 genów chorób recesywnych oraz 16 genów dziedziczonych w sposób sprzężony z chromosomem X. Test ten zapewnia wysoką gwarancję maksymalnego bezpieczeństwa zdrowotnego w zakresie zachorowalności i śmiertelności (np. SMA, mukowiscydoza)." },
          { title: "Pakiet Expanded", content: "Badanie skierowane do par, które chcą uzyskać „maksimum informacji genetycznych” przed poczęciem potomstwa. W tym wariancie test analizuje 552 geny, z czego 91 genów jest powiązanych z chromosomem X." },
          { title: "Dla kogo?", content: "Pary planujące ciążę naturalną lub IVF, które chcą zminimalizować ryzyko genetyczne u potomstwa." },
        ]}
        ctaLabel="Sprawdź zgodność"
        imageSrc="/assets/nuuma-couple.jpg"
      />

      <ProductSection
        id="natal"
        variant="extended"
        reverse={true}
        badgeType="remote"
        badgeLabel="Zdalnie · Próbki z Polski"
        title="Secure Natal – Bezpieczny NIPT"
        description={<>Bezpieczeństwo dziecka jest priorytetem od pierwszych tygodni ciąży. Secure Natal to nieinwazyjny test prenatalny (NIPT), który z niezwykłą precyzją analizuje wolne płodowe DNA krążące we krwi matki.<br /><br />Bezpieczny test, który z precyzją bliską 100% wyklucza najczęstsze wady genetyczne płodu, możliwy do wykonania już od 10. tygodnia ciąży.</>}
        accordions={[
          { title: "Bezpieczeństwo", content: "Bardzo wczesna diagnostyka prenatalna bez ryzyka dla płodu. Test wykonywany jest z krwi matki." },
          { title: "Czas i sposób wykonania", content: "Dostępny od 10. tygodnia ciąży. Badanie wykonuje się zdalnie. Wymaga jedynie prostego pobrania krwi w lokalnym punkcie, a wyniki wraz z profesjonalnym omówieniem przez specjalistę Nuuma Genetics otrzymasz w ciągu 7–9 dni roboczych." },
          { title: "Zakres", content: "Pozwala na wczesne wykrycie najczęstszych trisomii (zespół Downa, Edwardsa, Pataua), zaburzeń chromosomów płci oraz mikrodelecji, a także określenie płci dziecka." },
        ]}
        preCtaNote={<><strong>Secure Natal (Nieinwazyjne Badania Prenatalne – NIPT)</strong></>}
        ctaLabel="Zabezpiecz zdrowie dziecka"
        imageSrc="/assets/numa-tetst.webp"
      />

      <ProductSection
        id="ivf"
        variant="extended"
        reverse={false}
        imageBleed={true}
        badgeType="remote-ivf"
        badgeLabel="Stacjonarnie · Klinika w Hiszpanii"
        title="Genetyka Reprodukcyjna i IVF"
        description="Bezpośredni dostęp do hiszpańskiej jakości medycznej dla pacjentów klinik leczenia niepłodności oraz par planujących in vitro. Wsparcie par na każdym etapie planowania rodziny. Nasze badania pomagają zidentyfikować potencjalne przeszkody genetyczne, które mogą wpływać na płodność lub zdrowie przyszłego potomstwa. To wiedza, która pozwala lekarzom dobrać optymalną ścieżkę leczenia i zwiększyć szansę na zdrową ciążę."
        accordions={[
          { title: "Zakres", content: "To kompleksowy pakiet diagnostyczny stworzony dla osób borykających się z niepłodnością lub planujących zaawansowane leczenie metodą in vitro (IVF). Obejmuje on zarówno diagnostykę przyczyn niepowodzeń (np. badania kariotypu, trombofilii czy mutacji genu CFTR, premutacja FMR1.), jak i zaawansowane badania zarodków." },
          { title: "Miejsce wykonania", content: "Część diagnostyczna (np. badania krwi) może być zlecona zdalnie lub wykonana w miejscu zamieszkania. Jednak kluczowe badania zarodków, takie jak PGT-A (badanie chromosomów) czy PGT-SR (wykrywanie zmian strukturalnych), są integralną częścią procesu medycznego realizowanego bezpośrednio w klinice w Hiszpanii podczas procedury IVF." },
        ]}
        ctaLabel="Skonsultuj wsparcie IVF"
        imageSrc="/assets/nuuma-genetics-lab.webp"
        imageCaption="Laboratorium Nuuma · Alicante"
      />

      <WhySpain />
      <Process />
      <ContactForm />
      <EventPopup />
    </>
  );
}
